import { useQuery } from '@tanstack/react-query'
import { client } from '../lib/api-client'

export function useEvents(league: string) {
  return useQuery({
    queryKey: ['events', league],
    queryFn: async () => {
      const response = await client.api.v1.events.$get({
        query: {
          league,
        },
      })
      if (!response.ok) {
        throw new Error('Failed to fetch events')
      }
      return response.json()
    },
    refetchInterval: 3000, // fetch every 3 seconds
  })
}
